/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from '../../utils/cx';
import Dropdown from '../../../legacy/flux/components/form/Dropdown.react';
import CheckboxQuestion from '../../../legacy/flux/components/questions/CheckboxQuestion.react';
import RadioQuestion from '../../../legacy/flux/components/questions/RadioQuestion.react';
import Text from '../../../legacy/flux/components/form/Text.react';
import TextareaQuestion from '../../../legacy/flux/components/questions/TextareaQuestion.react';

const DailyPollQuestion = (props) => {
  const {
    poll,
    setFormData,
    handleSubmit,
    submitStatus,
    allowSubmit,
  } = props;

  let answerItem = null;
  switch (poll.type) {
    case 'dropdown':
      answerItem = (
        <Dropdown
          setFormData={setFormData}
          name={poll.id}
          options={poll.answers}
          valueKey="_id"
          label="title"
          noEmptyOption={allowSubmit}
        />
      );
      break;
    case 'checkbox':
      answerItem = (
        <CheckboxQuestion
          setFormData={setFormData}
          name={poll.id}
          answers={poll.answers}
        />
      );
      break;
    case 'radio':
      answerItem = (
        <RadioQuestion
          setFormData={setFormData}
          name={poll.id}
          options={poll.answers}
          valueKey="_id"
          label="title"
        />
      );
      break;
    case 'text':
      answerItem = (
        <Text
          name={poll.id}
          setFormData={setFormData}
        />
      );
      break;
    case 'textarea':
      answerItem = (
        <TextareaQuestion
          name={poll.id}
          setFormData={setFormData}
        />
      );
      break;
    default:
      answerItem = (
        <div>
          {`ERROR: Unknown question type: ${poll.type}`}
        </div>
      );
  }

  return (
    <div className="dailyPoll-question">
      <div className="mbs twb">
        { poll.title }
      </div>
      <form id="DailyPoll" onSubmit={handleSubmit}>
        {answerItem}
        <button
          type="submit"
          className={cx([
            'btn btn--a btn--small mts mbxs',
            ['has-loader', submitStatus === 'loading'],
          ])}
        >
          {get(translations, 'txt: Atbildēt', 'txt: Atbildēt')}
        </button>
      </form>
    </div>
  );
};

DailyPollQuestion.propTypes = {
  poll: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitStatus: PropTypes.string,
  allowSubmit: PropTypes.bool,
};

DailyPollQuestion.defaultProps = {
  submitStatus: null,
  allowSubmit: false,
};

export default DailyPollQuestion;
